import { AlertTriangle, AlertCircle, Info } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import type { EnergyAlert } from '@/types/energy';

interface EnergyAlertStripProps {
  alerts: EnergyAlert[];
}

export function EnergyAlertStrip({ alerts }: EnergyAlertStripProps) {
  if (alerts.length === 0) return null;

  const getAlertIcon = (severity: EnergyAlert['severity']) => {
    switch (severity) {
      case 'critical':
        return <AlertCircle className="h-4 w-4" />;
      case 'warning':
        return <AlertTriangle className="h-4 w-4" />;
      default:
        return <Info className="h-4 w-4" />;
    }
  };

  const getAlertStyles = (severity: EnergyAlert['severity']) => {
    switch (severity) {
      case 'critical':
        return 'border-destructive/50 text-destructive bg-destructive/10';
      case 'warning':
        return 'border-yellow-500/50 text-yellow-600 dark:text-yellow-500 bg-yellow-500/10';
      default:
        return 'border-border';
    }
  };

  return (
    <div className="space-y-2">
      {alerts.map(alert => (
        <Alert
          key={alert.id}
          className={`${getAlertStyles(alert.severity)} py-2`}
        >
          <div className="flex items-center gap-2">
            {getAlertIcon(alert.severity)}
            <AlertDescription className="text-sm flex-1">
              {alert.message}
            </AlertDescription>
          </div>
        </Alert>
      ))}
    </div>
  );
}
